import { useQuery } from "@tanstack/react-query";
import { promptPreviewApi, type PromptPreviewDto } from "@/api/reportsV32";

// LLM & Reports v3.2 §6.7 — local prompt-assembly preview. Backend does
// no Anthropic call; the response includes the assembled prompt body,
// per-content-block summaries, and the heuristic token budget the user
// would consume on the next Generate click.
//
// refetchOnWindowFocus is intentionally off: the preview is moderately
// expensive (the backend re-runs ingestion on every attached document
// to count tokens) and we don't want to thrash it when the user
// alt-tabs back to the wizard.
export function usePreviewPrompt(submissionId: string | null) {
  return useQuery<PromptPreviewDto>({
    queryKey: ["preview-prompt", submissionId],
    queryFn: () => promptPreviewApi.preview(submissionId!),
    enabled: Boolean(submissionId),
    refetchOnWindowFocus: false,
  });
}
